// src/pages/Dashboard/ReceiverDashboard.jsx
import React from 'react';
import {
  TrendingUp, Clock, Package,
  Filter, Download, Bell
} from 'lucide-react';
import '../../assets/css/receiverdashboard/ReceiverDashBoard.css';
import ReceiverMasterLayout from '../../components/layout/ReceiverMasterLayout';
import { useNavigate } from 'react-router-dom';

const ReceiverDashBoard = () => {

  const navigate = useNavigate();

  const statsData = [
    { id: 1, title: 'Total Received',   value: 'PKR 245,000', subValue: '+125 Items',        icon: TrendingUp, color: '#1F7A7A', trend: '+12.5%',    trendUp: true  },
    { id: 2, title: 'Pending Requests', value: '8',           subValue: 'Awaiting Response', icon: Clock,      color: '#FFB800', trend: '3 Urgent',  trendUp: false },
    { id: 3, title: 'Upcoming Pickup',  value: '3',           subValue: 'Next: 2 Days',      icon: Package,    color: '#FF6B4A', trend: 'This Week', trendUp: false }
  ];

  const recentDonations = [
    { id: 1, date: '12 Jan 2026', item: '50kg Rice',      donor: 'Ali Khan',    status: 'Delivered',   amount: 'PKR 8,500'  },
    { id: 2, date: '10 Jan 2026', item: 'Cash Donation',  donor: 'Anonymous',   status: 'In Progress', amount: 'PKR 25,000' },
    { id: 3, date: '08 Jan 2026', item: 'Medical Kit',    donor: 'Health Org',  status: 'Pending',     amount: 'PKR 12,000' },
    { id: 4, date: '05 Jan 2026', item: 'Winter Clothes', donor: 'Sara Ahmed',  status: 'Delivered',   amount: 'PKR 15,500' },
    { id: 5, date: '03 Jan 2026', item: 'Food Package',   donor: 'Charity Hub', status: 'Delivered',   amount: 'PKR 18,000' }
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case 'Delivered':   return 'rd-status-delivered';
      case 'In Progress': return 'rd-status-progress';
      case 'Pending':     return 'rd-status-pending';
      default:            return '';
    }
  };

  const handleCreateRequest = () => navigate('/receiver/create-request');

  return (
    <ReceiverMasterLayout>
      <div className="rd-dashboard-container">

        {/* Header */}
        <div className="rd-dashboard-header">
          <div className="rd-header-content">
            <div>
              <h1 className="rd-dashboard-title">Dashboard Overview</h1>
              <p className="rd-dashboard-subtitle">Welcome back, Fatima! Here's what's happening today.</p>
            </div>
            <div className="rd-header-actions">
              <button className="rd-action-btn rd-notification-btn">
                <Bell size={20} />
                <span className="rd-notification-badge">5</span>
              </button>
              
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="rd-stats-grid">
          {statsData.map((stat) => (
            <div key={stat.id} className="rd-stat-card">
              <div className="rd-stat-icon" style={{ background: `${stat.color}20` }}>
                <stat.icon size={24} style={{ color: stat.color }} />
              </div>
              <div className="rd-stat-content">
                <p className="rd-stat-label">{stat.title}</p>
                <h3 className="rd-stat-value">{stat.value}</h3>
                <div className="rd-stat-footer">
                  <span className="rd-stat-subvalue">{stat.subValue}</span>
                  <span className={`rd-stat-trend ${stat.trendUp ? 'rd-trend-up' : 'rd-trend-down'}`}>
                    {stat.trend}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Table */}
        <div className="rd-table-card">
          <div className="rd-table-header">
            <div>
              <h3 className="rd-table-title">Recent Donations</h3>
              <p className="rd-table-subtitle">Latest incoming donations</p>
            </div>
            <div className="rd-table-actions">
              <button className="rd-action-btn-small"><Filter size={16} /> Filter</button>
              <button className="rd-action-btn-small"><Download size={16} /> Export</button>
            </div>
          </div>
          <div className="rd-table-container">
            <table className="rd-donations-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Item/Amount</th>
                  <th>Donor Name</th>
                  <th>Value</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {recentDonations.map((donation) => (
                  <tr key={donation.id}>
                    <td className="rd-table-date">{donation.date}</td>
                    <td className="rd-table-item">{donation.item}</td>
                    <td className="rd-table-donor">{donation.donor}</td>
                    <td className="rd-table-amount">{donation.amount}</td>
                    <td>
                      <span className={`rd-status-badge ${getStatusClass(donation.status)}`}>
                        {donation.status}
                      </span>
                    </td>
                    <td><button className="rd-view-btn">View</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </ReceiverMasterLayout>
  );
};

export default ReceiverDashBoard;